import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { UserStore } from "../stores/user-store";

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userStore = inject(UserStore);

  // Si l'utilisateur est déjà connecté dans le store, autoriser l'accès

  if (userStore.isLoggedIn()) {
    return true;
  }

  router.navigate(['/login']);
  return false;
};